export const roundHours = (n: number) => parseFloat(n.toFixed(1))

export const roundDays = (hours: number, hoursPerDay: number) =>
  parseFloat((hours / hoursPerDay).toFixed(1))

export const formatCurrency = (value: number): string =>
  Math.round(value).toLocaleString('de-DE', { maximumFractionDigits: 0 })

export const currencyFormatter = new Intl.NumberFormat('de-DE', {
  style: 'currency',
  currency: 'EUR',
  minimumFractionDigits: 2,
})
